<template>
   <div id="toast-container">
    <b-alert
      :show="dismissCountDown"
      dismissible
      fade
      :variant="variant"
      @dismiss-count-down="countDownChanged"
    >
    <b-row>
      <b-col cols="2" md="1" class="d-flex justify-content-center align-items-center">
        <img 
          v-if="icon" 
          :src="require(`@/assets/images/icons/${icon}.svg`)" 
          alt="Icon"
        />
      </b-col>
      <b-col cols="10" md="11">
        {{ message}}
      </b-col>
    </b-row>      
    </b-alert>
   </div>
</template>

<script>
export default {
    data() {
        return {
            dismissSecs: 3,
            dismissCountDown: 0,
            message: "",
            variant: "",
            variantIcons: {
                success: "check-circle-fill-green",
                danger: "x-circle-fill-red",
                warning: "exclamation-point-fill-yellow",
                info: "info-fill-blue"
            }
        };
    },
    computed: {
        icon() {
            if (this.variant) return this.variantIcons[this.variant];

            return "";
        }
    },
    methods: {
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown;
        },
        openToast() {
            this.dismissCountDown = this.dismissSecs;
        }
    },
    mounted() {
        this.$root.$on("openToast", (message, variant = "success") => {
            this.message = message;
            this.variant = variant;
            this.openToast();
        });
    },
    beforeDestroy() {
        this.$root.$off("openToast");
    }
};
</script>
<style lang="scss">
#toast-container {
    .alert {
        top: 25%;
        margin: auto;
        position: fixed;
        left: 0;
        right: 0;
        width: 443px;
        min-height: 50px;
        z-index: 3000;
        border-radius: 6px;
        font-family: MainFontRegular, sans-serif;
        font-size: 16px;
        color: #2b2f38;
    }
    .alert-dismissible .close {
        color: #667085;
        font-family: MainFontRegular, sans-serif;
        font-size: 23px;
    }
    .alert-success {
        background-color: #e9f5ef;
        border-color: #68bb94;
    }
    .alert-danger {
        background-color: #fde7e7;
        border-color: #f49191;
    }
    .alert-warning {
        background-color: #fff8e9;
        border-color: #ffcd6c;
    }
    .alert-info {
        background-color: #eaeffd;
        border-color: #9db7f7;
    }
}
</style>
